<template>
<div class="ground-floor tw-flex tw-flex-col tw-items-center amount-requested tw-px-4 lg:tw-pt-20 lg:tw-mb-0 tw-mb-48">
    <div class="tw-flex tw-flex-col tw-items-center tw-mt-6 tw-w-full">
    <title-section 
    title="Planta"
    subtitle="¿En qué piso está tu vivienda?"></title-section>
    <div
        class="tw-flex tw-items-center tw-mt-8 size-container"
    >
        <div class="tw-flex tw-flex-col size-container-items">
            <div class="tw-text-left tw-w-full tw-mb-4">
                <p>Planta</p>
                <p class="optional">¿En qué piso se situa?</p>
            </div>
            <div class="tw-flex">
                <label
                class="mdc-text-field mdc-text-field--outlined mdc-text-field--no-label tw-mr-4 tw-w-full"
                >
                <input
                    v-model="floor"
                    class="mdc-text-field__input"
                    type="number"
                    aria-label="Label"
                />
                <span class="mdc-notched-outline">
                    <span class="mdc-notched-outline__leading"></span>
                    <span class="mdc-notched-outline__trailing"></span>
                </span>
                </label>
                <img src="/img/icons/icon-least.webp" class="button-plus tw-mr-4"  :class="floor == 0 || floor == '' ? 'disabled' : ''" @click="floor--"/>
                <img src="/img/icons/icon-plus.webp" class="button-plus"  @click="floor++"/>
            </div>
        </div>
    </div>
    <div
        class="tw-flex tw-flex-col tw-items-center tw-mt-8 size-container"
    >
        <div class="tw-flex tw-flex-col size-container">
            <div class="tw-text-left tw-w-full tw-mb-4">
                <p>Plantas totales</p>
                <p class="optional">Plantas totales en tu edificio</p>
            </div>
            <div class="tw-flex">
                <label
                class="mdc-text-field mdc-text-field--outlined mdc-text-field--no-label tw-mr-4 tw-w-full"
                >
                <input
                    v-model="floorTotals"
                    class="mdc-text-field__input"
                    type="number"
                    aria-label="Label"
                />
                <span class="mdc-notched-outline">
                    <span class="mdc-notched-outline__leading"></span>
                    <span class="mdc-notched-outline__trailing"></span>
                </span>
                </label>
                <img src="/img/icons/icon-least.webp" class="button-plus tw-mr-4"  :class="floorTotals == 0 || floorTotals == '' ? 'disabled' : ''" @click="floorTotals--"/>
                <img src="/img/icons/icon-plus.webp" class="button-plus"  @click="floorTotals++"/>
            </div>
        </div>
    </div>
    <div
        class="tw-flex tw-flex-col tw-items-center tw-mt-8 size-container"
    >
    <div class="tw-flex tw-flex-col size-container">
            <div class="tw-text-left tw-w-full tw-mb-4">
                <p>Puerta</p>
                <p class="optional">Número o letra</p>
            </div>
            <div class="tw-flex">
                <label
                class="mdc-text-field mdc-text-field--outlined mdc-text-field--no-label tw-w-full"
                >
                <input
                    v-model="door"
                    class="mdc-text-field__input input-door"
                    type="text"
                    aria-label="Label"
                />
                <span class="mdc-notched-outline">
                    <span class="mdc-notched-outline__leading"></span>
                    <span class="mdc-notched-outline__trailing"></span>
                </span>
                </label>
            </div>
        </div>
    </div>
    </div>
    <div class="fixed-button-mobile tw-mt-8">
    <button
        @click="goNextStep(floor, floorTotals, door)"
        class="btn btn-primary fixed-button btn-steps tw-flex tw-items-center tw-justify-center"
        :class="{ active: floor && floorTotals && door}"
    >
        Siguiente
    </button>
    </div>
</div>
</template>

<script>
import { MDCTextField } from "@material/textfield";
import { mapGetters, mapMutations } from "vuex";

export default {
data: () => ({
    floor: "",
    floorTotals: "",
    door: ""
}),
computed: {
    ...mapGetters({
    wizard: "getWizard",
    }),
},
methods: {
    ...mapMutations(["selectFloor", "selectFloorsTotal" , "selectDoor"]),
    goNextStep(floor, floorsTotal, door){
        if(floor && floorsTotal && door){
            this.selectFloor(floor);
            this.selectFloorsTotal(floorsTotal);
            this.selectDoor(door);
            this.$router.push({ name: "Occupied" });
        }
    }
},

mounted() {
    const textField = new MDCTextField(
    document.querySelector(".mdc-text-field")
    );
},
};
</script>
  
<style lang="scss">
@import "../../../sass/variables";
.ground-floor {
    .btn-primary {
        margin-left: auto;
        margin-right: auto;
        height: 48px;
        border-radius: 6px;
        transition: all 0.4s ease-in-out;
        background-color: $color-grey-hover;

        &:hover {
            background-color: $color-grey-hover;
        }

        &.active {
        background-color: $primary;
        }
    }
    .material-icons {
        font-size: 18px;
    }
    input {
        width: 377px;
        font-size: 16px;
        @media(max-width: $lg){
            width: 100%;
        }
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .btn-steps {
      @media(max-width: $lg){
        left: 3%;
      }
    }
    .subtract {
        padding-bottom: 2.3rem;
    }
    .input-door {
        width: 510px;
        @media(max-width: $lg){
            width: 100%;
        }
    }
}

</style>
  